import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'jd-library/Button';
import ExportImportDownloadButton from '../bulkupdatehistory/ExportImportDownloadButton';
import { getExportErrorFileLink, setCookie } from '../utils/bulkupdate.utils';
import { notifyCatalogueCreated } from '../../../../utills';
import historyHandler from 'jd-library/historyHandler';
import { fetchTabData } from '../../productinventory.getdata.utils';
import { bulkUpdateSteps } from '../constants/bulkupdateinventory.constants';

const UploadProgress = (props) => {
  const state = useSelector((state) => state.productInventory);
  const dispatch = useDispatch();
  const [itemDetails, setitemDetails] = useState({
    completionPercentage: 0,
    status: 'GENERATING_FILE',
    fileStatus: 'PENDING'
  })
  const [currentStep, setCurrentStep] = useState({
    currentStep: 0,
    mongoId: props.step.mongoId
  });
  let tempVal;
  // const getIosFilePath = async (url) => {
  //   let iosUrl = await axios.get(url);
  //   let iosFilePath = iosUrl.data?.filePath;
  //   setErrorFileLink(iosFilePath);
  // }

  const updateLoader = () => {
    const params = {
      token: props.session.token,
      jobType: 'INVENOTRY_IMPORT',
      jobId: currentStep.mongoId
    }
    let url = '/vendorapis/products/inventory/getInventoryProgress';
    axios.get(url, { params }).then((res) => {
      let status = res.data?.status || res.data?.jobStatus;
      if (res.data.isFirstProduct && [23].includes(props.session.jdSource)) {
        notifyCatalogueCreated();
      }
      if (status == 'UPDATE_FAILED') {
        status = 'FAILED'
      }
      if (status == 'COMPLETED') {
        status = 'DONE'
      }
      if (status == 'UPDATING' || status == 'GENERATING_FILE') {
        status = 'PENDING'
      }
      if (status == 'PARTIALLY_COMPLETED') {
        status = 'PARTIAL'
      }
      setitemDetails(() => ({ ...itemDetails, ...res.data, status: res.data.jobStatus, fileStatus: status }));
      if (status != 'PENDING' && status != 'STARTED') {
        let completionPercentage = res.data.completionPercentage;
        if (status == 'DONE' || status == 'PARTIAL' || status == 'FAILED') {
          completionPercentage = 100;
        }
        if (props.isJdSourceIOS || props.isJdBusinessIOS) {
          let urlToSend = errorUrl + `&source=${sourceCheck.source}`;
          getIosFilePath(urlToSend);
        }
        if (currentStep.currentStep === 0) {
          setCookie('currentStep', '');
          setCookie('fileId', '');
          if (status == 'FAILED') {
            setCurrentStep({ ...currentStep, currentStep: 1 });
          }
          else {
            setTimeout(() => {
              setCurrentStep({ ...currentStep, currentStep: 1 });
            }, 1000);
          }
        }
        return;
      }
    })
  }
  useEffect(() => {
    if (itemDetails.completionPercentage < 100 && (itemDetails.status === 'GENERATING_FILE' || itemDetails.status === 'UPDATING')) {
      setTimeout(() => {
        updateLoader();
      }, 4000)
    }
  }, [itemDetails]);

  let circleRef = React.useRef(null);
  if (currentStep.currentStep === 0) {
    return (
      <div className='uploading-file'>
        <div id="cont" data-pct="100">
          <svg id="svg" width="5rem" height="5rem" viewPort="0 0 2.5rem 2.5rem" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <circle r="32" cx="2.5rem" cy="2.5rem" fill="transparent" stroke-dasharray="239" stroke-dashoffset="0"></circle>
            <circle ref={circleRef} id="bar" r="32" cx="2.5rem" cy="2.5rem" fill="transparent" stroke-dasharray="200" stroke-dashoffset={`${200 - 2 * itemDetails?.completionPercentage}`}></circle>
          </svg>
          <div className='catalogue-percentage' style={{ fontSize: '1.6rem' }}>{Math.round(itemDetails.completionPercentage)}%</div>
        </div>
        <div className='prog-heading'>
          Upload in Progress
        </div>
        {<div className='prog-sub-heading with-continue'>
          <div className='mgb-15'>This may take few minutes. You can continue using the system while the upload is in progress.</div>
          <div className='mgb-15'>You can check the status of upload by clicking on <i className="icon-glHistory" /> in Bulk Upload Inventory section.</div>
          <Button
            size='lg'
            className='continue-btn'
            clickHandler={() => props.setStep({ step: bulkUpdateSteps.history })}
          >
            Continue
          </Button>
        </div>}
      </div>
    )
  }
  return (
    <div className='upload-progress'>
      <div className='status-icon'>
        {itemDetails.fileStatus == 'DONE' && <i className='icon-Checkmark success'></i>}
        {itemDetails.fileStatus == 'PARTIAL' && <i className='icon-alert_outline2 partial-success'></i>}
        {itemDetails.fileStatus == 'FAILED' && <i className='icon-alert_outline2 failed'></i>}
      </div>
      <div className='status-heading'>
        {itemDetails.fileStatus == 'DONE' ? `Inventory Uploaded Successfully` : null}
        {itemDetails.fileStatus == 'PARTIAL' ? `Inventory Partially Updated` : null}
        {itemDetails.fileStatus == 'FAILED' ? `Inventory Upload Failed` : null}
      </div>
      {(itemDetails.fileStatus == 'PARTIAL' || itemDetails.fileStatus == 'FAILED') &&
        <>
          <div className='status-sub-heading'>
            {itemDetails.fileStatus === 'PARTIAL' && <div className='partial-count'>{itemDetails?.totalProductsSaved}/{itemDetails?.totalUnits} Products Updated</div>}
            {(itemDetails.fileStatus === 'PARTIAL') ? <div className='mgb-22'>
            </div> : null}
            <div className='steps-header'>Please follow the steps given below to rectify the error</div>
            <div className='steps'>
              <div>1. Download Error File</div>
              <div>2. Correct the Errors in the Downloaded File</div>
              <div>3. Reupload the Updated File</div>
            </div>
          </div>
          <ExportImportDownloadButton
            label="Download Error file"
            fileName="error.xlsx"
            size='lg'
            variant="primary"
            className='view-prod-btn'
            url={getExportErrorFileLink(itemDetails.jobId, props?.session?.token)}
          />
        </>
      }
      {(itemDetails.fileStatus == 'DONE') ?
        <div className='status-sub-heading'>
          {`Please note that images for the uploaded are being fetched from the uploaded links and will be shown against the in sometime.`}
        </div> : null
      }
      {itemDetails.fileStatus == 'DONE' && (<>
        <Button
          size='lg'
          className='view-prod-btn'
          variant="primary"
          clickHandler={() => {
            const { func } = fetchTabData(state);
            dispatch(func());
            props.onClose();
            historyHandler.closeCurrent();
          }}
        >
          Go To Inventory
        </Button>
      </>
      )
      }
      <Button
        variant='default'
        size='lg'
        className='upload-another'
        clickHandler={() => props.setStep({ step: bulkUpdateSteps.initial })}
      >
        Upload Another File
      </Button>
      {(itemDetails.fileStatus == 'PARTIAL') ? (<>
        <Button
          variant='default'
          size='lg'
          className='view-product-partial'
          clickHandler={() => {
            const { func } = fetchTabData(state);
            dispatch(func());
            props.onClose();
            historyHandler.closeCurrent();
          }}
        >
          Go To Inventory
        </Button>
      </>
      ) : null
      }
    </div>
  )
}

export default UploadProgress;